import { fromHttpPromise } from 'pulse/adapters';
import userInfo from 'hub-http/userInfo';
import { makeCrmSearchRequest, makeCrmSearchAllPropertiesRequest } from './api';
import { extractUserId } from './getUserId';
export const defaultCrmSearchResolver = fromHttpPromise('defaultCrmSearchResolver', makeCrmSearchRequest);
export const defaultCrmSearchAllPropertiesResolver = fromHttpPromise('defaultCrmSearchAllPropertiesResolver', (http, args) => makeCrmSearchAllPropertiesRequest(http, args, () => userInfo({
  ignoreRedirect: true
}).then(extractUserId)));